"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavedViewsService = void 0;
class SavedViewsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Paginates CRM saved views information
     * @param page
     * @param count
     * @returns ListSavedViewsRes
     * @throws ApiError
     */
    listSavedViews(page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/views/',
            query: {
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Creates a saved view information.
     * @param requestBody
     * @returns SuccessIdResponse
     * @throws ApiError
     */
    createSavedView(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/views/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Paginates saved views information by type
     * @param viewType saved view type
     * @param page
     * @param count
     * @returns ListSavedViewsRes
     * @throws ApiError
     */
    listSavedViewsByType(viewType, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/views/{viewType}',
            path: {
                'viewType': viewType,
            },
            query: {
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Updates saved view information by id.
     * @param id saved view uuid
     * @param requestBody
     * @returns UpdateResponse
     * @throws ApiError
     */
    updateSavedView(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/views/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Deletes a saved view information.
     * @param id saved view uuid
     * @returns DeleteResponse
     * @throws ApiError
     */
    deleteSavedView(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/views/{id}',
            path: {
                'id': id,
            },
        });
    }
}
exports.SavedViewsService = SavedViewsService;
